import { useEffect, useCallback } from "react";
import { config } from "../config";
import { UIState } from "../types/chat";

interface UseDynamicUIParams {
  dynamicRoute?: string | null;
  location: { pathname: string };
  setUiState: React.Dispatch<React.SetStateAction<UIState>>;
}

export function useDynamicUI({ dynamicRoute, location, setUiState }: UseDynamicUIParams) {
  const apiUrl = config.API_URL.replace(/\/+$/, "");

  const configureDynamicPageUI = useCallback(
    async (pageName: string) => {
      try {
        const resp = await fetch(`${apiUrl}/api/dynamic-pages`);
        if (!resp.ok) return false;
        const data = await resp.json();
        const pageInfo = data.pages_detail?.[pageName];
        if (pageInfo) {
          const displayName = pageInfo.display_name || pageName;
          setUiState(prev => ({
            ...prev,
            title: `Bem-vindo ao assistente virtual do ${displayName}!`,
            subTitle: `Coloque aqui as suas questoes ou duvidas sobre este curso.`,
            examples: [
              `"Pergunte algo relacionado com ${displayName}."`,
              `"Por exemplo: 'Quais os topicos do ${displayName}?'"`
            ],
            supportLink: "https://suporte.insia.pt/"
          }));
          return true;
        }
      } catch {
        return false;
      }
      return false;
    },
    [apiUrl, setUiState]
  );

  useEffect(() => {
    const configure = async () => {
      if (dynamicRoute && dynamicRoute !== "/") {
        const pageName = dynamicRoute.replace("/", "");
        const configured = await configureDynamicPageUI(pageName);
        if (configured) return;
      }

      setUiState({
        title: "Bem-vindo ao assistente virtual do FORINSIA",
        subTitle: "Coloque aqui as suas questoes ou duvidas sobre a utilizacao do software.",
        examples: [
          "\"Os formandos nao aparecem na lista de participantes.\"",
          "\"Como eliminar utilizadores?\"",
          "\"Como forcar alocacao de formandos?\""
        ],
        supportLink: "https://suporte.insia.pt/"
      });
    };

    configure();
  }, [configureDynamicPageUI, dynamicRoute, location.pathname, setUiState]);
}